import '@ant-design/compatible/assets/index.css';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';
import modal from '~components/modal';
import { Spin } from 'antd';

@modal(
  {
    className: 'loading-modal',
  },
  true,
)
class LoadingModal extends React.Component {
  render() {
    const { title } = this.props;

    return (
      <div className="loading-modal-container">
        <div className="loading-modal-container__header">
          {title}
          <CloseOutlined
            className="loading-modal-container__close-button"
            onClick={this.props.handleCloseModal}
          />
        </div>
        <div className="loading-modal-container__body">
          <Spin size="large" />
        </div>

        <div />
      </div>
    );
  }
}

LoadingModal.propTypes = {
  title: PropTypes.string.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};

LoadingModal.defaultProps = {
  title: '',
  handleCloseModal: () => {},
};

export default LoadingModal;
